var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.0003,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14V12C21 9.23858 18.7614 7 16 7C13.2386 7 11 9.23858 11 12V14M16 18.5V20.5M12.8 25H19.2C20.8802 25 21.7202 25 22.362 24.673C22.9265 24.3854 23.3854 23.9265 23.673 23.362C24 22.7202 24 21.8802 24 20.2V18.8C24 17.1198 24 16.2798 23.673 15.638C23.3854 15.0735 22.9265 14.6146 22.362 14.327C21.7202 14 20.8802 14 19.2 14H12.8C11.1198 14 10.2798 14 9.63803 14.327C9.07354 14.6146 8.6146 15.0735 8.32698 15.638C8 16.2798 8 17.1198 8 18.8V20.2C8 21.8802 8 22.7202 8.32698 23.362C8.6146 23.9265 9.07354 24.3854 9.63803 24.673C10.2798 25 11.1198 25 12.8 25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.caaa8839ade4316bbf66c666501e87f7.svg";
export { ForwardRef as ReactComponent };